/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, Input, Optional } from '@angular/core';
import { AppRouter, TitleManager } from '@gh/common-shared';
import { compact } from 'lodash';
import { CONTEXTABLE_COMPONENT, ContextableComponent } from '../../routing';
import { AbstractPageHeaderComponent } from './abstract-page-header.component';

@Component({
  standalone: false,
  selector: 'gh-page-header',
  templateUrl: 'page-header.component.html',
  styleUrls: ['page-header.component.scss'],
})
export class PageHeaderComponent extends AbstractPageHeaderComponent {
  @Input() back: boolean;
  @Input() parentTitle: string;
  @Input() icon: string;
  @Input() pageTitle: string;
  @Input() entityGroupTitle: string;
  @Input() entityTitle: string;
  @Input() supTitle: string;
  @Input() documentParentTitle: string;
  @Input() documentTitle: string;
  @Input() documentEntityTitle: string;
  @Input() widthFull: boolean;

  get hasBack(): boolean {
    return this.back && !!(this.parentRoute || this.contextable || this.router.state.parentRoute);
  }

  constructor(router: AppRouter,
              titleManager: TitleManager,
              @Optional() @Inject(CONTEXTABLE_COMPONENT) contextable?: ContextableComponent) {
    super(router, titleManager, contextable);
  }

  protected buildTitle(): Maybe<string> {
    if (this.documentTitle || this.documentEntityTitle) {
      return compact([
        this.documentParentTitle,
        compact([this.documentTitle, this.documentEntityTitle]).join(': '),
      ]).join(' - ');
    }
    if (this.pageTitle || this.entityTitle) {
      return compact([
        this.documentParentTitle,
        compact([this.pageTitle, this.entityTitle]).join(': '),
      ]).join(' - ');
    }
  }
}
